<div class="relative" *ngIf="userInfo$" [ngClass]="{ 'cursor-pointer': clickable, inactive: outOfOfficeMessage }" [matTooltip]="(tooltip$() | async) || ''">
  <figure
    *ngIf="!userProfileURL && !blankImageFlag && (userInfo$ | async)?.name"
    [ngStyle]="{ width: size + 'px', height: size + 'px', 'background-color': '#C9C9C9' }"
    (click)="onClick()"
    class="sp-avatar-figure text-figure flex rounded-full justify-center items-center"
  >
    <span [ngStyle]="{ fontSize: fontSize + 'px' }" class="font-medium">
      {{ userInfo$ | nameInitials | async }}
    </span>
  </figure>
  <div class="user-email mt-1 inline-block w-full" *ngIf="!userProfileURL && !blankImageFlag && !(userInfo$ | async)?.name && (userInfo$ | async)?.email">
    <span>{{ (userInfo$ | async)?.email }}</span>
  </div>
  <figure class="sp-avatar-figure image-figure relative" *ngIf="userProfileURL && !blankImageFlag">
    <img
      [ngStyle]="{ width: size + 'px', height: size + 'px', 'background-color': 'white' }"
      (click)="onClick()"
      class="rounded-full !object-cover shadow-lg"
      [src]="userProfileURL"
      (error)="imgLoadError()"
      alt="img"
    />
  </figure>
  <figure
    *ngIf="blankImageFlag"
    [ngStyle]="{ width: size + 'px', height: size + 'px', 'background-color': '#C9C9C9' }"
    (click)="onClick()"
    class="sp-avatar-figure text-figure flex rounded-full justify-center items-center"
  >
    <span [ngClass]="blankImageSize" class="font-medium">
      <mat-icon aria-hidden="true" [ngClass]="blankImageSize">
        <span [ngClass]="blankImageSize" class="material-icons-outlined">person</span>
      </mat-icon>
    </span>
  </figure>
  <div *ngIf="annotationStatus" class="annotationStatus" [ngClass]="[annotationStatus, annotationClass]">
    <ng-container [ngSwitch]="annotationStatus">
      <ng-container *ngSwitchCase="'annotated'">
        <mat-icon aria-hidden="true" class="matIcon">
          <span class="material-icons-outlined statusIcon">rotate_right</span>
        </mat-icon>
      </ng-container>
      <ng-container *ngSwitchCase="'opened'">
        <mat-icon aria-hidden="true" class="matIcon">
          <span class="material-icons-outlined statusIcon">priority_high</span>
        </mat-icon>
      </ng-container>
      <ng-container *ngSwitchCase="'submitted'">
        <mat-icon aria-hidden="true" class="matIcon">
          <span class="material-icons-outlined statusIcon">done</span>
        </mat-icon>
      </ng-container>
    </ng-container>
  </div>
</div>
